export const styles = {
  formWrap: {
    borderBottom: '1px solid #d9d9d9',
    backgroundColor: '#fff',
  },
}



// WEBPACK FOOTER //
// ./src/Containers/StatsDeliverability/Charts/ChartHeader/styles.js